import { Link } from "gatsby";
import React, { useState } from "react";
import useTranslation, {
  DEFAULT_LANGUAGE,
} from "../../src/hooks/useTranslation";
import { AILogo, SalutoLogo, TopBarLogo } from "../commons/Icons/Icons";
import LanguageSelector from "./LanguageSelector";
import Drawer from "./Drawer";
import { LeftOutlined } from "@ant-design/icons";
interface TopbarProps {
  pathName: string;
}
function Topbar(props: TopbarProps) {
  const { t, setLanguage, language, buildHref } = useTranslation(
    props.pathName
  );

  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <>
      <div className="hidden sm:flex w-full bg-slate-100 sticky top-0 z-50">
        <div className="w-4/5 sm:h-20 h-14 flex mx-auto justify-between items-center ">
          <div className="h-full py-3 flex items-center gap-x-2 ">
            <Link className="m-auto" to={buildHref("")}>
              <SalutoLogo></SalutoLogo>
            </Link>
            <a
              rel="noopener norefferer"
              href="https://www.ai-startups.se/"
              target="_blank"
            >
              <AILogo></AILogo>
            </a>
          </div>
          <div className="gap-x-24  flex-1 flex justify-end items-center mr-16">
            <Link activeStyle={{ fontWeight: 500 }} to={buildHref("")}>
              <p className="cursor-pointer">{t("Home")}</p>
            </Link>

            <Link
              activeStyle={{ fontWeight: 500 }}
              to={buildHref("metabolic/")}
            >
              <p className="cursor-pointer">{t("Metabolic health")}</p>
            </Link>

            <Link activeStyle={{ fontWeight: 500 }} to={buildHref("about/")}>
              <p className="cursor-pointer">{t("About us")}</p>
            </Link>

            {/* <p className="cursor-pointer">{"Contact"}</p> */}
            <LanguageSelector pathName={props.pathName}></LanguageSelector>
          </div>
        </div>
      </div>

      <div className="h-16 sm:hidden justify-end items-center flex w-full bg-slate-100 sticky top-0 z-10 ">
        <div className="w-full sm:h-20 h-14 flex mx-auto justify-between items-center ">
          <div className="h-full p-1 ml-6 ">
            <Link className="m-auto" to={buildHref("")}>
              <SalutoLogo></SalutoLogo>
            </Link>
          </div>
          <div className="text-3xl mr-5">
            <LeftOutlined onClick={() => setIsOpen(true)} />
          </div>
        </div>
      </div>

      <div className=" flex w-3/4 ">
        <Drawer setIsOpen={setIsOpen} isOpen={isOpen}>
          <div className="px-5 pt-5 flex flex-col  h-full">
            <Link activeStyle={{ fontWeight: 500 }} to={buildHref("")}>
              <p className="cursor-pointer ">{t("Home")}</p>
            </Link>

            <Link
              activeStyle={{ fontWeight: 500 }}
              to={buildHref("metabolic/")}
            >
              <p className="cursor-pointer">{t("Metabolic health")}</p>
            </Link>
            <Link activeStyle={{ fontWeight: 500 }} to={buildHref("about/")}>
              <p className="cursor-pointer">{t("About")}</p>
            </Link>
            <div className="mt-auto  ">
              <LanguageSelector pathName={props.pathName}></LanguageSelector>
            </div>
          </div>
        </Drawer>
      </div>
    </>
  );
}

export default Topbar;
